export const homeBtnMoneyHandler = {
  homeBtnMoneyHandler_deposit: "Deponeer",
  homeBtnMoneyHandler_withdraw: "Onttrek",
  homeBtnMoneyHandler_transfer: "Oopskakel",

  homeBtnMoneyHandler_balance: "Huidige saldo",
};
